import React from 'react';
import { Route } from 'react-router-dom';
import CardCourses from '../Pages/Courses/CardCourses/CardCourses.js';
import CourseCancilBooking from '../Pages/Courses/CourseCancilBooking/CourseCancilBooking.js';
import CourseOutline from '../Pages/Courses/CourseOutline/CourseOutline.js';
import SettingContentSupport from '../Pages/SettingScreens/SettingContentSupport/SettingContentSupport.js';
import SettingSubscription from '../Pages/SettingScreens/SettingSubscription/SettingSubscription.js';
import FlowSubjectDetails from '../Pages/Flow/subjectDetails/subjectDetails.js';





//booking expert started
const ExpertUpcomeingAndPastSessions = React.lazy(() => import('../Pages/Expert/ExpertScreens/ExpertUpcomeingAndPastSessions/ExpertUpcomeingAndPastSessions.js'));
const ExpertSessionsProfile = React.lazy(() => import('../Pages/Expert/ExpertScreens/ExpertSessionsProfile/ExpertSessionsProfile.js'));
const ExpertSessionsSettings = React.lazy(() => import('../Pages/Expert/ExpertScreens/ExpertSessionsSettings/ExpertSessionsSettings.js'));
const TransactionHistory = React.lazy(() =>
  import('../Pages/Expert/ExpertScreens/TransactionHistory/TransactionHistory.js')
);

const ConnectStrip = React.lazy(() => import("../Pages/Expert/ExpertScreens/ExpertSessionsSettings/ConnectStrip.js"))
//booking expert ended

//become expert started
const ExpertProfile = React.lazy(() => import('../Pages/Expert/BecomeExpertScreens/ExpertProfile/ExpertProfile.js'));
const ExpertKnlodge = React.lazy(() => import('../Pages/Expert/BecomeExpertScreens/ExpertKnlodge/ExpertKnlodge.js'));
const ExpertIdentity = React.lazy(() => import('../Pages/Expert/BecomeExpertScreens/ExpertIdentity/ExpertIdentity.js'));
const ExpertVerify = React.lazy(() => import('../Pages/Expert/BecomeExpertScreens/ExpertVerify/ExpertVerify.js'));

//become expert ended



// signin screen started
const HomeDashBoard = React.lazy(() => import("../Pages/RecessDashBoard/HomeDashBoard.js"));
const SettingDetails = React.lazy(() => import('../Pages/SettingScreens/SettingDetails/SettingDetails.js'));
const SettingFavourite = React.lazy(() => import('../Pages/SettingScreens/SettingFavourite/SettingFavourite.js'));
const SettingLearningSession = React.lazy(() => import('../Pages/SettingScreens/SettingLearningSession/SettingLearningSession.js'));
const SettingNotification = React.lazy(() => import('../Pages/SettingScreens/SettingNotification/SettingNotification.js'));
const SettingSignInScreen = React.lazy(() => import('../Pages/SettingScreens/SettingSignInScreen/SettingSignInScreen.js'));
const SettingPrivacy = React.lazy(() => import('../Pages/SettingScreens/SettingPrivacy/SettingPrivacy.js'));
const SettingWallet = React.lazy(() => import('../Pages/SettingScreens/SettingWallet/SettingWallet.js'));
const SettingWalletpayment = React.lazy(() => import('../Pages/SettingScreens/SettingWallet/SettingPaymentDetails.js'));
const SettingChangePassword = React.lazy(() => import('../Pages/SettingScreens/SettingChangePassword/SettingChangePassword.js'));
const SettingNameScreen = React.lazy(() => import('../Pages/SettingScreens/SettingNameScreen/SettingNameScreen.js'));
// signin screen ended



//  expert screens started
const ExpertSessions = React.lazy(() => import("../Pages/Expert/ExpertScreens/ExpertSessions/ExpertSessions.js"));
// const BecomeExpertNavBar = React.lazy(() => import('../RecessNavbar/BecomeExpertNavBar/BecomeExpertNavBar.js'))
const BecomeExpertMainScreen = React.lazy(() => import('../Pages/Expert/BecomeExpertScreens/BecomeExpertMainScreen/BecomeExpertMainScreen.js'))
const BecomeExpert = React.lazy(() => import('../Pages/Expert/BecomeExpertScreens/BecomeExpert/BecomeExpert.js'));
const ExpertCongras = React.lazy(() => import('../Pages/Expert/BecomeExpertScreens/ExpertCongras/ExpertCongras.js'))
const ExpertNotApprove = React.lazy(() => import('../Pages/Expert/BecomeExpertScreens/ExpertNotApprove/ExpertNotApprove.js'))

//  expert screen ended




// setting screens started
const SettingsMainScreen = React.lazy(() => import("../Pages/SettingScreens/SettingsMainScreen/SettingsMainScreen.js"));
const OtherUserProfile = React.lazy(() => import("../Pages/OtherUserProfile/OtherUserProfile.js"));
const PreSession = React.lazy(() => import("../Pages/OtherUserProfile/Pre-Session/PreSession.js"));
const BookSession = React.lazy(() => import("../Pages/OtherUserProfile/BookSession/BookSession.js"));
const StartSession = React.lazy(() => import("../Pages/OtherUserProfile/StartSession/StartSession.js"));
const ConfirmBooking = React.lazy(() => import("../Pages/OtherUserProfile/ConfirmBooking/ConfirmBooking.js"));
const DoneBooking = React.lazy(() => import("../Pages/OtherUserProfile/BookingConfirmed/DoneBooking.js"));
const ExpertNotification = React.lazy(() => import("../Pages/OtherUserProfile/ExpertNotification/ExpertNotification.js"));

const Subjectbookmark = React.lazy(() => import("../Pages/OtherUserProfile/Subject_bookmark/subject_bookmark.js"));
// setting screen ended




// Agora Screens

//video screen 
const VideoAudioScreen = React.lazy(() => import("../Components/agora/AgoraVideo/Video.js"));
const AudioScreen = React.lazy(() => import("../Components/agora/AgoraAudio/Audio.js"));
const ChatScreen = React.lazy(() => import("../Components/agora/AgoraChat/Chat.js"));

// Recording screen 
const RecordingScreen = React.lazy(() => import("../Components/agora/AgoraRecording/Recording.js"));




//Flow Screen
const Flow = React.lazy(() => import("../Pages/Flow/flow.js"));
const Industry = React.lazy(() => import("../Pages/Industry/industry.js"));





export const AppRoutes = (
    <Route>
        <Route path='/' index element={<Flow />} />
        <Route path='/BecomeExpertMainScreen' element={<BecomeExpertMainScreen />} >
            <Route path='BecomeExpert' element={<BecomeExpert />} />
            <Route path='ExpertProfile' element={<ExpertProfile />} />
            <Route path='ExpertKnlodge' element={<ExpertKnlodge />} />
            <Route path='ExpertIdentity' element={<ExpertIdentity />} />
            <Route path='ExpertVerify' element={<ExpertVerify />} />
            <Route path='ExpertCongras' element={<ExpertCongras />} />
            <Route path='ExpertNotApprove' element={<ExpertNotApprove />} />
        </Route>

        <Route path='/ExpertCongras' element={<ExpertCongras />} />
        <Route path='/VideoScreen' element={<VideoAudioScreen />} />
        <Route path='/AudioScreen' element={<AudioScreen />} />
        <Route path='/ChatScreen' element={<ChatScreen />} />
        <Route path='/RecordingScreen' element={<RecordingScreen />} />
        <Route path='/ExpertNotApprove' element={<ExpertNotApprove />} />

        <Route path='/ExpertSessions' element={<ExpertSessions />} >
            <Route path='ExpertUpcomeingAndPastSessions' element={<ExpertUpcomeingAndPastSessions />} />
            <Route path='ExpertSessionsProfile' element={<ExpertSessionsProfile />} />
            <Route path='ExpertSessionsSettings' element={<ExpertSessionsSettings />} />
            <Route path='TransactionHistory' element={<TransactionHistory />} />
            <Route path='ConnectStrip' element={<ConnectStrip />} />
        </Route>

        <Route path='/OtherUserProfile' element={<OtherUserProfile />} />
        <Route path='/PreSession' element={<PreSession />} />
        <Route path='/BookSession' element={<BookSession />} />
        <Route path='/StartSession' element={<StartSession />} />
        <Route path='/ConfirmBooking' element={<ConfirmBooking />} />
        <Route path='/DoneBooking' element={<DoneBooking />} />
        <Route path='/ExpertNotification' element={<ExpertNotification />} />

        <Route path='/SettingsMainScreen' element={<SettingsMainScreen />}>
            <Route path='SettingSignInScreen' element={<SettingSignInScreen />} />
            <Route path='SettingNotification' element={<SettingNotification />} />
            <Route path='SettingDetails' element={<SettingDetails />} />
            <Route path='SettingLearningSession' element={<SettingLearningSession />} />
            <Route path='SettingFavourite' element={<SettingFavourite />} />
            <Route path='SettingWallet' element={<SettingWallet />} />
            <Route path='SettingSubscription' element={<SettingSubscription />} />
            <Route path='SettingPaymentDetails' element={<SettingWalletpayment />} />
            <Route path="SettingPrivacy" element={<SettingPrivacy />} />
            <Route path="SettingChangePassword" element={<SettingChangePassword />} />
            <Route path="SettingNameScreen" element={<SettingNameScreen />} />
            {/* <Route path="SettingContentSupport" element={<SettingContentSupport />} /> */}
        </Route>


        <Route path='/Subject_bookmark' element={<Subjectbookmark />} />
        <Route path='/CardCourses' element={<CardCourses />} />
        <Route path='/CourseOutline' element={<CourseOutline />} />
        <Route path='/CourseCancilBooking' element={<CourseCancilBooking />} />
        <Route path="/SettingContentSupport" element={<SettingContentSupport />} />



        <Route path='/HomeScreen' element={<HomeDashBoard />}></Route>
        <Route path='/Industry' element={<Industry />}></Route>
         <Route path='/Flowsubjectdetails' element={<FlowSubjectDetails />}></Route>
        


    </Route>


);